module.exports = __webpack_public_path__ + "img/mk_logo.ee28f726.jpeg";